import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { StoreModel, User } from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';

export const getFilterConfig = ({
  t,
  stores,
  users,
}: {
  t: TFunction;
  stores: Partial<StoreModel>[];
  users: Partial<User>[];
}) => [
  {
    id: 'storeIds',
    size: 4,
    type: FilterItemType.Multiselect,
    props: {
      multiple: true,
      inputProps: {
        placeholder: t('common.store-id'),
        variant: 'outlined',
        name: 'storeIds',
        label: t('common.store-id'),
      },
      options: stores.map((store) => ({
        value: store.id,
        name: store.nationalStoreNumber,
      })),
      fullWidth: true,
    },
  },
  {
    id: 'assignedToUserIds',
    size: 4,
    type: FilterItemType.Custom,
    render: (props: any) => {
      return (
        <UsersServerSideField {...props} multiple={true}></UsersServerSideField>
      );
    },
    props: {
      inputProps: {
        placeholder: t('common.assigned-to'),
        variant: 'outlined',
        name: 'assignedToUserIds',
        label: t('common.assigned-to'),
      },
      fullWidth: true,
    },
  },
];
